module.exports = __webpack_public_path__ + "img/server2.a8b491c7.svg";